import { render, staticRenderFns } from "./Zhaosheng.vue?vue&type=template&id=ca1a2242&scoped=true&"
import script from "./Zhaosheng.vue?vue&type=script&lang=js&"
export * from "./Zhaosheng.vue?vue&type=script&lang=js&"
import style0 from "./Zhaosheng.vue?vue&type=style&index=0&id=ca1a2242&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1a2242",
  null
  
)

export default component.exports